import React, { useState } from 'react';

const CourseToggle = () => {
    // State variable to track visibility
    const [isVisible, setIsVisible] = useState(false);

    // Function to toggle visibility
    const toggleDescription = () => {
        setIsVisible(prevState => !prevState);
    };

    return (
        <div>
            <button className="btn btn-primary" onClick={toggleDescription} style={{ width: '190px' }}>
                {isVisible ? 'Hide Description' : 'Show Description'}
            </button>
            {isVisible && (
                <p className="card-text" style={{ margin: '10px 0' }}>
                    This course covers React fundamentals including components, JSX, and props.
                </p>
            )}
        </div>
    );
};

export default CourseToggle;
